<template>
  <div class="modal" v-if="seen">
    <div class="upload_browse_folder">
      <div class="p-4">
        <div class="d-flex justify-content-between align-items-center">
          <h4>
            <span>Add Users to Folder({{ folder_name }})</span>
          </h4>
          <span @click="closebox" class="close_advanced_search">
            <img src="@/assets/search-icons/Close.svg" />
          </span>
        </div>
        <template>
          <div class="finduser sharefile-find-user">
            <input
              type="text"
              placeholder="Find a user..."
              @keyup="search_user"
            />
            <img src="@/assets/search-icon.svg" />
          </div>
          <div class="selected-user">
            <span
              v-for="(select, index) in selected_users"
              class="selected"
              :key="index"
            >
              <span class="remove" @click="remove_user(select._id)">
                <svg style="width: 16px; height: 16px" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                  />
                </svg>
              </span>
              <span class="img">
                <template v-if="select.photo">
                  <span class="profile-pic">
                    <img :src="getPhoto(select.photo)" width="24px" height="auto" />
                  </span>
                </template>
                <template v-else>
                  <span class="profile-initials">{{
                    getInitials(select.names)
                  }}</span>
                </template>
              </span>
              {{ select.names }}
            </span>
          </div>
          <hr class="mb-0" />
          <div class="cgn browsefolder">
            <template v-if="isLoadingUsers"
              ><div class="py-3">
                <svg
                  width="120px"
                  height="120px"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid"
                  class="lds-dual-ring"
                  style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%"
                >
                  <circle
                    cx="50"
                    cy="50"
                    fill="none"
                    stroke-linecap="round"
                    r="20"
                    stroke-width="4"
                    stroke="#039aed"
                    stroke-dasharray="31.41592653589793 31.41592653589793"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      calcMode="linear"
                      values="0 50 50;360 50 50"
                      keyTimes="0;1"
                      dur="1s"
                      begin="0s"
                      repeatCount="indefinite"
                    ></animateTransform>
                  </circle>
                </svg></div
            ></template>
            <template v-else>
              <template v-if="$store.getters.ACCT_TYPE == 1">
                <template v-if="users.length === 0">
                  <div class="no-user">
                    <h5>No user found</h5>
                    <p>Invite a friend to collaborate with</p>
                    <p>
                      <span class="btn-invite" @click="invite"
                        >Send Invite</span
                      >
                    </p>
                  </div>
                </template>
                <template v-else>
                  <ul class="selected_folders">
                    <li
                      v-for="(name, index) in users"
                      :key="index"
                      :ref="'l_' + index"
                      class="s-user"
                    >
                      <div class="user">
                        <div class="user-data">
                          <div
                            @click="folder_right(name._id, 'can_view', index)"
                            class="d-flex flex-grow-1"
                          >
                            <CirleCheckIcon
                              class="check-svg"
                              v-if="
                                selected_users &&
                                selected_users.find(
                                  (el) => el._id === name._id || el === name._id
                                )
                              "
                            />
                            <UnCheckedIcon class="check-svg" v-else />
                            <span class="img">
                              <template v-if="name.photo">
                                <span class="profile-pic">
                                  <img :src="getPhoto(name.photo)" />
                                </span>
                              </template>
                              <template v-else>
                                <span class="profile-initials">{{
                                  getInitials(name.names)
                                }}</span>
                              </template>
                            </span>
                            <span class="dir">
                              <strong>{{ name.names }}</strong>
                              <br />
                              <span class="dept"
                                >Department: {{ name.department }}</span
                              >
                            </span>
                          </div>

                          <b-dropdown
                            size="sm"
                            toggle-class="text-decoration-none btn-light border-0 menu-btn"
                            menu-class="drop-down-menu-class"
                            no-caret
                          >
                            <template #button-content>
                              {{
                                setShareRightsText({
                                  canView: name.canView,
                                  canCreate: name.canCreate,
                                  canEdit: name.canEdit,
                                  canPrint: name.canPrint,
                                  canDownload: name.canDownload,
                                })
                              }}
                              &nbsp; <DropdownChevronDownIcon />
                            </template>
                            <div class="rights">
                              <label
                                :class="[name.canView ? 'disabled-label' : '']"
                                @change="
                                  folder_right(name._id, 'can_view', index)
                                "
                              >
                                <input type="checkbox" v-model="name.canView" />
                                <CheckIcon v-if="name.canView" /><UnCheckedIcon
                                  v-else
                                />
                                View
                              </label>

                              <label
                                @change="
                                  folder_right(name._id, 'can_create', index)
                                "
                                ><input
                                  type="checkbox"
                                  v-model="name.canCreate"
                                />
                                <CheckIcon
                                  v-if="name.canCreate"
                                /><UnCheckedIcon v-else />
                                Create
                              </label>

                              <label
                                @change="
                                  folder_right(name._id, 'can_edit', index)
                                "
                              >
                                <input type="checkbox" v-model="name.canEdit" />
                                <CheckIcon v-if="name.canEdit" /><UnCheckedIcon
                                  v-else
                                />
                                Edit
                              </label>
                              <label
                                @change="
                                  folder_right(name._id, 'can_download', index)
                                "
                              >
                                <input
                                  type="checkbox"
                                  v-model="name.canDownload"
                                />
                                <CheckIcon
                                  v-if="name.canDownload"
                                /><UnCheckedIcon v-else />Download
                              </label>
                              <label
                                @change="
                                  folder_right(name._id, 'can_print', index)
                                "
                              >
                                <input
                                  type="checkbox"
                                  v-model="name.canPrint"
                                />
                                <CheckIcon v-if="name.canPrint" /><UnCheckedIcon
                                  v-else
                                />Print
                              </label>
                            </div>
                          </b-dropdown>
                        </div>
                        <!--<span
                        :class="[
                          isSelected(name._id)
                            ? 'selected-close'
                            : 'hidden-close',
                        ]"
                        @click="remove_user(name._id)"
                      >
                        <svg
                          style="width: 16px; height: 16px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#000000"
                            d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                          />
                        </svg>
                      </span>-->
                      </div>
                    </li>
                  </ul>
                </template>
              </template>
              <template v-else>
                <ul class="selected_folders">
                  <li
                    v-for="(name, index) in users"
                    :key="index"
                    :ref="'l_' + index"
                    class="s-user"
                  >
                    <div class="user">
                      <div class="user-data">
                        <div
                          @click="folder_right(name._id, 'can_view', index)"
                          class="d-flex flex-grow-1"
                        >
                          <CirleCheckIcon
                            class="check-svg"
                            v-if="
                              selected_users &&
                              selected_users.find((el) => el._id === name._id || el === name._id)
                            "
                          />
                          <UnCheckedIcon class="check-svg" v-else />
                          <span class="img">
                            <template v-if="name.photo">
                              <span class="profile-pic">
                                <img :src="getPhoto(name.photo)" />
                              </span>
                            </template>
                            <template v-else>
                              <span class="profile-initials">{{
                                getInitials(name.names)
                              }}</span>
                            </template>
                          </span>
                          <span class="dir">
                            <strong>{{ name.names }}</strong>
                            <br />
                            <span class="dept"
                              >Department: {{ name.department }}</span
                            >
                          </span>
                        </div>

                        <b-dropdown
                          size="sm"
                          toggle-class="text-decoration-none btn-light border-0 menu-btn"
                          menu-class="drop-down-menu-class"
                          no-caret
                        >
                          <template #button-content>
                            {{
                              setShareRightsText({
                                canView: name.canView,
                                canCreate: name.canCreate,
                                canEdit: name.canEdit,
                                canPrint: name.canPrint,
                                canDownload: name.canDownload,
                              })
                            }}
                            &nbsp; <DropdownChevronDownIcon />
                          </template>

                          <div class="rights">
                            <label
                              @change="
                                folder_right(name._id, 'can_view', index)
                              "
                            >
                              <input type="checkbox" v-model="name.canView" />
                              <CheckIcon v-if="name.canView" /><UnCheckedIcon
                                v-else
                              />
                              View
                            </label>

                            <label
                              @change="
                                folder_right(name._id, 'can_create', index)
                              "
                              ><input
                                type="checkbox"
                                v-model="name.canCreate"
                              />
                              <CheckIcon v-if="name.canCreate" /><UnCheckedIcon
                                v-else
                              />
                              Create
                            </label>

                            <label
                              @change="
                                folder_right(name._id, 'can_edit', index)
                              "
                            >
                              <input type="checkbox" v-model="name.canEdit" />
                              <CheckIcon v-if="name.canEdit" /><UnCheckedIcon
                                v-else
                              />
                              Edit
                            </label>
                            <label
                              @change="
                                folder_right(name._id, 'can_download', index)
                              "
                            >
                              <input
                                type="checkbox"
                                v-model="name.canDownload"
                              />
                              <CheckIcon
                                v-if="name.canDownload"
                              /><UnCheckedIcon v-else />Download
                            </label>
                            <label
                              @change="
                                folder_right(name._id, 'can_print', index)
                              "
                            >
                              <input type="checkbox" v-model="name.canPrint" />
                              <CheckIcon v-if="name.canPrint" /><UnCheckedIcon
                                v-else
                              />Print
                            </label>
                          </div>
                        </b-dropdown>
                      </div>
                      <!--<span
                        :class="[
                          isSelected(name._id)
                            ? 'selected-close'
                            : 'hidden-close',
                        ]"
                        @click="remove_user(name._id)"
                      >
                        <svg
                          style="width: 16px; height: 16px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#000000"
                            d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                          />
                        </svg>
                      </span>-->
                    </div>
                  </li>
                </ul>
              </template>
            </template>
          </div>
        </template>
      </div>
      <div class="buttons d-flex justify-content-center align-items-center">
        <span class="upload_file" @click="saverights">
          <img src="@/assets/share-icon.svg" /> &nbsp;&nbsp;
          <span>Share File</span>
        </span>
      </div>
    </div>
    <loading ref="loading"></loading>
  </div>
</template>
<style scoped>
.check-svg {
  width: 1.125rem;
  height: 1.125rem;
  margin-left: 0.5rem;
  margin-right: -0.25rem;
}
.share_via_link {
  height: 300px;
}

.share_via_link .anyone {
  font-size: 0.875rem;
}

.share_via_link .view {
  font-size: 0.875rem;
}

.share_via_link p {
  font-size: 0.875rem;
  color: #4b5458;
  text-align: left;
  margin-top: 1.5em;
  margin-bottom: 10px;
}

.share_via_email p {
  font-size: 0.875rem;
  color: #4b5458;
  text-align: left;
  margin-top: 1.5em;
  margin-bottom: 10px;
}

.share_via_email textarea {
  font-size: 0.875rem;
  color: #4b5458;
  border: 1px solid #a7b9cb;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 12px 24px 12px 12px;
  height: 116px;
  display: inline-block;
  width: 100%;
  overflow-y: auto;
  margin-bottom: 1.7em;
}

.share_via_email p:last-child {
  font-size: 0.875rem;
  color: #677888;
  text-align: left;
  margin-top: 0;
}

.share_via_email p:last-child span {
  color: #4b5458;
  font-weight: bold;
}

.finduser {
  width: 100% !important;
  margin-top: 2em !important;
  margin-bottom: 1.5em !important;
}
.sharefile-find-user {
  width: 100% !important;
  position: relative;
}

.sharefile-find-user img {
  position: absolute;
  right: 0.6em;
  top: 0.6em;
}
.sharefile-find-user input {
  width: 100%;
  border: none;
  padding: 0.6em 0.5em;
  border-radius: 9px !important;
  background: #f2f7fc;
  font-size: 0.875rem;
}
.via {
  display: flex;
  flex-direction: row;
  font-size: 13px;
}

.via > span {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  padding: 0.5em 0.8em;
  box-sizing: border-box;
  border-radius: 6px;
  background: #f3f5f7;
  color: #677888;
  cursor: pointer;
}

.via .active-source {
  background: #d9ecfa;
  border: 1px solid #3f96d1;
  box-sizing: border-box;
  border-radius: 6px;
  color: #2a7bb1 !important;
}
.browse_folder_nav {
  margin: 15px 0;
}
.input {
  display: flex;
  flex-direction: column;
  justify-content: left;
}
.input label {
  font-size: 0.875rem;
  color: #4b5458;
  text-align: left;
}
.input input {
  border: 1px solid #a7b9cb;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 10px 12px;
  margin: 0 0 10px;
}
.buttons {
  background: #ffffff;
  box-shadow: 0px -4px 40px rgba(0, 0, 0, 0.06);
  padding: 1.3em 1.2em;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.selected_folders {
  height: 320px;
  overflow-y: auto;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
}
.selected_folders li {
  padding-left: 0;
}
h4 {
  font-size: 18px;
  font-weight: bold;
}
.browse_folder_nav {
  text-align: left;
}
.close_advanced_search {
  background: #f2f7fc;
  display: inline-flex;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.create_new_folder {
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  width: 132px;
  height: 42px;
  color: #3f96d1;
  border: 1px solid #3f96d1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
}

.upload_file {
  background: #3f96d1;
  cursor: pointer;
  border-radius: 9px;
  width: 100%;
  height: 42px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
}

.btn-save {
  background: transparent;
  cursor: pointer;
  border-radius: 5px;
  color: #3f96d1;
  border: 1px solid #3f96d1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  padding: 0.4em 0.6em;
  height: 40px;
}

.folder-name {
  border-radius: 8px;
  border: 1px solid #a7b9cb;
  padding: 0.6em 0.6em;
  width: 100%;
  flex-basis: auto;
}
.action-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1em;
}
.btn-cancel {
  background: #fc6d6c;
  cursor: pointer;
  border-radius: 5px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  padding: 0.4em 0.6em;
  height: 40px;
}
.upload_browse_folder {
  background: #fff;
  border-radius: 8px;
  width: 460px;
  margin: 0 12px;
}

.browsefolder {
  width: 100% !important;
}
.modal {
  display: flex;
}
.cgn {
  display: flex;
  flex-direction: column;
}
.btn-continue {
  cursor: pointer;
  background: rgba(1, 46, 84, 1);
  color: #fff;
  padding: 0.6em 0.8em;
  font-size: 13px;
}
.sharefile-find-user input {
  width: 100%;
  border: 1px #f1f1f1 solid;
  border-radius: 2px;
  padding: 0.6em 0.8em;
}
.save .save-btn .savebtn {
  background: #1e6abb !important;
  font-size: 12px !important;
  height: 36px !important;
  padding: 0 1em !important;
  margin-top: 1em;
}
.save-btn {
  display: flex;
  flex-direction: row !important;
  margin-left: 0 !important;
  width: 100% !important;
}
.save-btn span {
  background: none !important;
}
.save .save-btn .share-options span {
  color: #333 !important;
  font-size: 0.875rem !important;
}
.save .save-btn .share-options span:hover {
  text-decoration: underline;
}
.single-user .header h3 {
  display: flex;
  justify-content: space-between;
}
.single-user .finduser {
  margin-top: 2em;
  margin-bottom: 2em;
}
.single-user .finduser p:first-child {
  font-size: 0.875rem;
}
.single-user .finduser p:last-child {
  padding: 0.9em;
  border: 1px solid #999;
}
.selected-user {
  margin-top: 0.6em;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.remove {
  cursor: pointer;
  color: #a7b9cb;
}
.file-title {
  margin-top: 0.5em;
}
.sharetype {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.6em;
}
.sharetype span:last-child {
  margin-left: 0.8em;
}
.sharetype span {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.type_link {
  display: flex;
  flex-direction: column !important;
}
.selected-user .selected {
  background: #fff;
  border: 1px solid #ced8e1;
  font-size: 12px;
  font-weight: 600;
  padding: 0.2em 0.6em;
  margin-right: 0.25rem;
  display: inline-block;
  border-radius: 50px;
  display: flex;
  width: fit-content;
  gap: 0.25rem;
  color: #111;
}
.selected-user .selected .img {
  width: 1.75rem;
  height: 1.75rem;
}
.finduser > p {
  font-size: 0.875rem;
  margin-bottom: 0.5em !important;
}
.finduser .email input {
  border: none;
  padding: 5px 3px;
  outline: 0;
  width: 100%;
}
.finduser .err {
  color: #fc6d6c;
  border: none !important;
  padding: 0 !important;
}
.save {
  flex-direction: column !important;
  margin-top: 0 !important;
}
.finduser .email-text {
  background: rgb(223, 220, 220);
  color: #333;
  display: inline-flex;
  justify-content: center;
  font-size: 0.875rem;
  align-items: center;
  padding: 2px 8px;
  border-radius: 3px;
  margin-right: 0.5em;
}
.finduser .email-text .fa {
  display: inline-block;
  margin-left: 0.5em;
  font-size: 12px;
  color: #fc6d6c;
}
.finduser .email {
  border: 1px solid rgb(230, 230, 230);
  padding: 3px 3px;
  margin: 0;
  outline: 0;
  display: flex;
  margin-top: 0.4em !important;
  width: 100%;
}
.selected_folders li {
  display: block;
}
.selected_folders li:last-child {
  display: block;
  border-bottom: none;
}
.selected_folders li:hover {
  background: none;
}
.selected_folders li .user {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  width: 100%;
  min-height: inherit;
}

.selected_folders li .user .img {
  height: 2rem;
  width: 2rem;
  font-size: 0.875rem;
  margin: 0;
}
.selected_folders li .user .dir {
  margin: 0;
}

.selected_folders li .user .dept {
  font-size: 0.75rem;
  color: #677888;
}
.selected_folders li .user .add-user {
  cursor: pointer;
  height: 38px;
  display: flex;
  background-color: #1e6abb;
  border-radius: 3px;
  border: none;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  width: 80px;
}
.selected_folders li .user div {
  display: flex;
  align-items: center;
  margin: 0;
}
.selected_folders li .rights {
  display: flex;
  align-items: center;
  margin: 0;
  margin-top: 0.5em !important;
  width: 100%;
  flex-direction: column;
}
.selected_folders li .rights label {
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0.5rem 0.5rem;
  font-size: 0.875rem;
  gap: 0.25rem;
}

.selected_folders li .rights label input {
  display: none;
}
.selected_folders li .rights label svg {
  width: 1rem !important;
  height: 1rem !important;
  color: #2a7bb1;
  pointer-events: none;
}

.selected_folders li .rights label .unchecked {
  visibility: hidden;
}

.selected_folders li .rights label:hover .unchecked {
  visibility: visible;
}
.modal {
  display: flex;
}
.cgn {
  display: flex;
  flex-direction: column;
}
.cgn span {
  margin-bottom: 0.4em;
}
.profile-initials {
  background-color: rgba(226, 232, 240, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border-radius: 100%;
  font-size: 1.125rem;
  color: rgba(113, 128, 150, 1);
  margin: 0;
}
.mbd {
  width: 85%;
  overflow: hidden;
  text-overflow: ellipsis !important;
  white-space: nowrap;
}
.selected-close {
  display: none;
}
.hidden-close {
  display: none;
}
.user:hover .selected-close {
  display: block;
}
.user-data {
  cursor: default;
  justify-content: space-between;
  width: 100%;
}
.d-flex {
  gap: 1rem;
}

.s-user {
  min-height: 3.5rem;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.s-user:hover {
  background-color: #f2f7fc !important;
}
.s-user:hover .profile-initials {
  /* background-color: #fff !important; */
}

.dir {
  text-align: left;
}
</style>

<script>
import loading from "@/components/Loading";
import cookies from "@/services/cookies";
import { mapState } from "vuex";
import CirleCheckIcon from "@/components/Icons/CircleCheckIcon";
import DropdownChevronDownIcon from "@/components/Icons/DropdownChevronDownIcon";
import CheckIcon from "@/components/Icons/CheckIcon";
import UnCheckedIcon from "@/components/Icons/UnCheckedIcon";
export default {
  components: {
    loading,
    CirleCheckIcon,
    DropdownChevronDownIcon,
    CheckIcon,
    UnCheckedIcon,
  },
  data() {
    return {
      names: [],
      seen: false,
      loader: false,
      error: false,
      found: false,
      folder_id: null,
      folder_name: "",
      await_status: false,
      selected_users: [],
      stored_users: [],
      can_view: [],
      can_edit: [],
      can_create: [],
      can_print: [],
      can_download: [],
      folder_users: [],
      account_type: "",
      isLoadingUsers: false,
    };
  },
  computed: {
    ...mapState(["backendUrl"]),
    users: function () {
      let that = this;
      return this.names.filter(function (name) {
        return !name.is_selected;
      });
    },
  },
  methods: {
    setShareRightsText(rights) {
      return rights.canCreate
        ? "Create"
        : rights.canEdit
        ? "Edit"
        : rights.canView
        ? "View"
        : rights.canDownload
        ? "Download"
        : rights.canPrint
        ? "Print"
        : "View";
    },
    invite() {
      this.seen = false;
      this.$parent.invite();
    },
    isSelected(id) {
      return this.selected_users.find((user) => user._id == id);
    },
    getPhoto(photo) {
      // console.log(typeof photo)
      // const pt = `${this.backendUrl}/static-photos/${photo}`
      return photo;
    },
    getInitials(name) {
      const nm = name;
      return nm.charAt(0);
    },
    useradded() {
      this.$parent.useradded();
    },
    notify(text) {
      this.$parent.notify(text);
    },
    logincall() {
      this.$parent.logincall();
    },
    str_text(str) {
      return str.length > 22 ? str.substr(0, 22) + "..." : str;
    },
    resetUser(id) {
      this.names = this.names.map((name) => {
        if (name._id === id) {
          name.canView = false;
          name.canCreate = false;
          name.canEdit = false;
          name.canDownload = false;
          name.canPrint = false;
        }
        return name;
      });
    },
    remove_user(id) {
      let index_of = this.folder_users.indexOf(id);
      this.folder_users.splice(index_of, 1);
      this.selected_users = this.selected_users.filter(
        (user) => user._id != id
      );
      this.resetUser(id);
    },
    search_user(evt) {
      if (evt.target.value) {
        let data = JSON.parse(JSON.stringify(this.stored_users));
        this.names = data.filter(function (user) {
          return user.names
            .toLowerCase()
            .includes(evt.target.value.toLowerCase());
        });
      } else {
        this.names = this.stored_users;
      }
    },
    select_user(index, right) {
      this.error = false;
      const user = this.names[index];
      const isFound = this.folder_users.indexOf(user._id);

      if (isFound === -1) {
        this.selected_users.push(user);
        this.folder_users.push(user._id);
        this.names.map((name) => {
          if (name._id === user._id) {
            name.canView = true;
            if (right === "can_create") {
              name.canCreate = true;
            } else if (right === "can_edit") {
              name.canEdit = true;
            } else if (right === "can_download") {
              name.canDownload = true;
            } else if (right === "can_print") {
              name.canPrint = true;
            }
          }
          return name;
        });
      }
    },
    folder_right(id, right, index) {
      if (right === "can_view") {
        let vIndex = this.can_view.indexOf(id);
        if (vIndex !== -1) {
          this.can_view.splice(vIndex, 1);
          let dIndex = this.can_download.indexOf(id);
          let eIndex = this.can_edit.indexOf(id);
          let pIndex = this.can_print.indexOf(id);
          if (dIndex === -1 && eIndex === -1 && pIndex === -1) {
            this.remove_user(id);
          }
        } else {
          this.can_view.push(String(id));
          this.select_user(index, right);
        }
      }
      if (right === "can_create") {
        let cIndex = this.can_create.indexOf(id);
        if (cIndex !== -1) {
          this.can_create.splice(cIndex, 1);

          let vIndex = this.can_view.indexOf(id);
          let eIndex = this.can_edit.indexOf(id);
          let dIndex = this.can_download.indexOf(id);
          let pIndex = this.can_print.indexOf(id);

          if (
            vIndex === -1 &&
            eIndex === -1 &&
            dIndex === -1 &&
            pIndex === -1
          ) {
            this.remove_user(id);
          }
        } else {
          this.can_create.push(String(id));
          this.select_user(index, right);
        }
      }

      if (right === "can_edit") {
        let eIndex = this.can_edit.indexOf(id);
        if (eIndex !== -1) {
          this.can_edit.splice(eIndex, 1);

          let vIndex = this.can_view.indexOf(id);
          let cIndex = this.can_create.indexOf(id);
          let dIndex = this.can_download.indexOf(id);
          let pIndex = this.can_print.indexOf(id);

          if (
            vIndex === -1 &&
            cIndex === -1 &&
            dIndex === -1 &&
            pIndex === -1
          ) {
            this.remove_user(id);
          }
        } else {
          this.can_edit.push(String(id));
          this.select_user(index, right);
        }
      }

      if (right === "can_download") {
        let dIndex = this.can_download.indexOf(id);
        if (dIndex !== -1) {
          this.can_download.splice(dIndex, 1);

          let vIndex = this.can_view.indexOf(id);
          let cIndex = this.can_create.indexOf(id);
          let eIndex = this.can_edit.indexOf(id);
          let pIndex = this.can_print.indexOf(id);

          if (
            vIndex === -1 &&
            cIndex === -1 &&
            eIndex === -1 &&
            pIndex === -1
          ) {
            this.remove_user(id);
          }
        } else {
          this.can_download.push(String(id));
          this.select_user(index, right);
        }
      }

      if (right === "can_print") {
        let pIndex = this.can_print.indexOf(id);
        if (pIndex !== -1) {
          this.can_print.splice(pIndex, 1);

          let vIndex = this.can_view.indexOf(id);
          let cIndex = this.can_create.indexOf(id);
          let eIndex = this.can_edit.indexOf(id);
          let dIndex = this.can_download.indexOf(id);

          if (
            vIndex === -1 &&
            cIndex === -1 &&
            eIndex === -1 &&
            dIndex === -1
          ) {
            this.remove_user(id);
          }
        } else {
          this.can_print.push(String(id));
          this.select_user(index, right);
        }
      }

      this.$forceUpdate();
    },
    saverights() {
      if (this.selected_users.length) {
        this.$refs.loading.load();
        let data = {
          can_create: this.can_create,
          can_edit: this.can_edit,
          can_download: this.can_download,
          can_print: this.can_print,
          selected_users: this.folder_users,
          token: cookies.getCookie("token"),
          folder_id: this.folder_id,
        };

        let that = this;
        this.$socket.emit("save-rights", data, function (data) {
          if (data.data === true) {
            that.$refs.loading.close();
            that.seen = false;
            that.selected_users = [];
            that.folder_users = [];
            that.names = [];
            that.can_edit = [];
            that.can_create = [];
            that.can_print = [];
            that.can_download = [];
            if (that.await_status != true) {
              that.useradded();
            } else {
              that.notify(that.folder_name + " is awaiting admin approval.");
            }
          }

          if (data.data === false) {
            that.done = false;
            that.loader = false;
            that.seen = false;
            that.selected_users = [];
            that.names = [];
            that.can_edit = [];
            that.can_create = [];
            that.can_print = [];
            that.can_download = [];
            that.logincall();
            that.$router.push('/login')
          }
        });
      } else {
        this.error = true;
      }
    },
    load(folder_id, folder_name, await_status = null) {
      this.account_type =
        this.$store.getters.ISSTAFF === true ||
        this.$store.getters.ISSUPERADMIN === true
          ? 2
          : 1;
      let that = this;
      this.seen = true;
      this.names = [];
      this.selected_users = [];
      this.folder_users = [];
      this.await_status = await_status;
      this.folder_name = folder_name;
      this.folder_id = folder_id;

      if (this.account_type == 2) {
        let data = {
          token: cookies.getCookie("token"),
          folder_id: folder_id,
        };

        this.isLoadingUsers = true;
        this.$socket.emit("load-folder-users", data, function (data) {
          if (data.data === true) {
            that.names = data.users;
            that.stored_users = data.users;
          }

          if (data.data === false) {
            that.seen = false;
            that.logincall();
            that.$router.push('/login')
          }

          that.isLoadingUsers = false;
        });
      } else {
        let data = {
          token: cookies.getCookie("token"),
        };
        this.isLoadingUsers = true;
        this.$socket.emit("get-friends", data, function (data) {
          if (data.data === true) {
            that.names = data.users;
            that.stored_users = data.users;
          }
          if (data.data === false) {
            that.seen = false;
            that.logincall();
            that.$router.push('/login')
          }
          that.isLoadingUsers = false;
        });
      }
    },
    closebox() {
      this.selected_users = [];
      this.names = [];
      this.can_edit = [];
      this.can_create = [];
      this.can_print = [];
      this.can_download = [];
      this.seen = false;
    },
  },
};
</script>
